module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAV1JREFUOE+l0r9rwkAUB/DvS0wQXEJd/AMEdwdnZ2knCbgIiraX6u4f0a2Dba4dFFwKwanF2dnBXfAPcClkKUjS5JUrVWqJobVvuh/vfe64e9Ttdm81TXMAmPhfBHEcu9TpdM50Xb8DUAeQOdF8BzCNoqhHAEgIUWTmJwDlE8ElETWklGsFfobjOJU4jmcA8n9EXzVNq7muu1B1e1BNhBAXzPwAoPBLdENEV1LK513+AWjbtm5ZlgBwQ0S5NJSZ3wAMfN+XnudFiaBabDabuWw2q0AF60fQiJnldrsdTCYTBe/j4Ia71VarVTAM45GIzpNAZn4Jw/ByPB5vfu4ngiqp3+/ngyCYEVHlexEzL0zTrA2Hw9ekw46CKrndbpcNw1DtVPwqXodh2BiNRstj75sKVqvVTKlUqjOzanwQUW+1Wk3n87lq5MRIBVWFbdumZVnXauz7/r3neUHa738AuQR4BtL+HMwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_arrow01.png
// module id = li6f
// module chunks = 5